let InfosModal = (function() {
  let self = {}

  self.init = function() {

      new Vue({
          delimiters: ["%%", "%%"],
          el: '#InfosModal',
          data: {
              InfosItemsLoaded: false,
              InfosItems: [],
              displayInfosModal: true,
              unreadInfosModal: true
          },
          methods: {
              changeInfosModal: function() {
                  this.displayInfosModal = !this.displayInfosModal
                  localStorage.displayInfosModal = this.displayInfosModal
                  this.unreadInfosModal = false
                  localStorage.unreadInfosModal = this.unreadInfosModal
              }
          },
          mounted: function() {
              self = this
              if (localStorage.displayInfosModal) {
                  self.displayInfosModal = JSON.parse(localStorage.displayInfosModal);
              }
              if (localStorage.unreadInfosModal) {
                  self.unreadInfosModal = JSON.parse(localStorage.unreadInfosModal);
              }
              fetch(apidae.site_url + 'wp-json/wp/v2/alertes')
                  .then(response => response.json())
                  .then(data => {
                      if (data.length > 0) {
                          self.InfosItemsLoaded = true
                          self.InfosItems = data
                      }
                  })
          }
      });
  };

  return self;
})();

if (document.getElementById('InfosModal')) {
  InfosModal.init();
}